import React, { useEffect, useRef } from 'react';
import styles from './PrivateEvents.module.css';
import YouMayAlsoLike from '../components/YouMayAlsoLike';

const PrivateEvents = ({ onNavigate }) => {
  const pageRef = useRef(null);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  return (
    <div ref={pageRef} className={styles['private-events-page']}>
      <div className={styles.container}>
        <h1 className={styles['page-title']}>Private Events</h1>
        
        <div className={styles['intro-section']}>
          <p>
            The Queens Hotel Harlech provides the perfect intimate setting for your special occasions. 
            Whether you're celebrating a milestone birthday, hosting a family gathering, or marking 
            life's important moments, our welcoming venue offers a warm and personal atmosphere.
          </p>
          <p>
            Our experienced team understands that every event is unique, and we're committed to working 
            with you to create memorable experiences. From small intimate gatherings to larger celebrations, 
            we can accommodate your needs with flexible arrangements and personalized service.
          </p>
        </div>

        <div className={styles['image-section']}>
          <img 
            src="/website_images/private_events.jpg" 
            alt="Private events space at The Queens Hotel"
            className={styles['event-image']}
          />
        </div>

        <div className={styles['contact-section']}>
          <h2 className={styles['section-title']}>Plan Your Event</h2>
          <p className={styles['contact-text']}>
            Ready to start planning your special event? We'd love to hear from you and discuss how 
            we can make your celebration memorable. Please get in touch with the following details:
          </p>
          <ul className={styles['contact-list']}>
            <li>Your preferred date and time</li>
            <li>Expected number of guests</li>
            <li>Type of event or celebration</li>
            <li>Any special requirements or requests</li>
            <li>Catering preferences</li>
          </ul>
          <div className={styles['contact-button-section']}>
            <a 
              href="mailto:thequeenshotelharlech@gmail.com?subject=Private Event Enquiry"
              className={styles['contact-button']}
            >
              Email Us About Your Event
            </a>
          </div>
        </div>
      </div>
      <YouMayAlsoLike currentPage="private-events" onNavigate={onNavigate} />
    </div>
  );
};

export default PrivateEvents;